/* global process */
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

import { loadStripe } from '@stripe/stripe-js'
import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js'

const CheckoutForm = ({ onConfirm, order }) => {
	const dispatch = useDispatch()
	const stripe = useStripe()
	const elements = useElements()
	const [form, setForm] = useState({
		visible: true,
		disable: false,
	})
	const [transaction, setTransaction] = useState({
		complete: false,
		approved: false,
	})

	const handleSubmit = async(event) => {
		// We don't want to let default form submission happen here,
		// which would refresh the page.
		event.preventDefault()

		setForm({
			...form,
			disable: true,
		})

		if (!stripe || !elements) {
		// Stripe.js has not yet loaded.
		// Make sure to disable form submission until Stripe.js has loaded.
			return
		}

		const result = await stripe.confirmCardPayment(order.client_secret, {
			payment_method: {
				card: elements.getElement(CardElement),
				billing_details: {
					name: `${order.surname} ${order.name}`,
				},
			}
		})

		if (result.error) {
			dispatch({ type: 'setFeedback@ui', message: result.error.message, color: 'error', hideDuration: 5000 })
			setForm({
				...form,
				disable: false,
			})
		} else {
			if (result.paymentIntent.status == 'succeeded') {
				// Verifico il pagamento
				const paymentCheck = await onConfirm(result.paymentIntent.id)
				setTransaction({
					completed: true,
					approved: true,
				})
				setForm({
					...form,
					visible: false,
				})
			} else {
				setTransaction({
					completed: true,
					approved: false,
				})
				setForm({
					...form,
					visible: false,
				})
			}
		}
	}

	return (<React.Fragment>
		{form.visible && <form onSubmit={handleSubmit}>
			<div style={{ marginBottom: 12 }}><CardElement /></div>
			<Button color="primary" variant="contained" type="submit" disabled={!stripe || form.disable}>Completa il pagamento</Button>
		</form>}
		{transaction.completed && <div>
			{transaction.approved && <p>Pagamento confermato</p>}
			{!transaction.approved && <p>Si è verificato un problema nel pagamento</p>}
		</div>}
	</React.Fragment>)
}

function Stripe({ chiavePubblica, onConfirm, order }) {
	const stripePromise = loadStripe(chiavePubblica)

	return (<div>
		<h4>Paga con carta di credito</h4>
		<div style={{ maxWidth: 400 }}>
			<Elements stripe={stripePromise}>
				<CheckoutForm
					order={order}
					onConfirm={onConfirm}
				/>
			</Elements>
		</div>
	</div>)
}

export default withStyles(style)(Stripe)
